import { render } from "./form.vue?vue&type=template&id=5d120afa&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"

import "./form.vue?vue&type=style&index=0&id=5d120afa&lang=scss&scoped=true"
import "./form.vue?vue&type=style&index=1&id=5d120afa&lang=scss"
script.render = render
script.__scopeId = "data-v-5d120afa"

export default script